<template>
    <minimal>
        <div class="text-center">
            <p>{{t('miscellaneous.service_unavailable')}}</p>
        </div>
    </minimal>
</template>

<script setup>
const Minimal = defineAsyncComponent(() => import('~/errors/minimal.vue'))

import {useI18n} from "vue-i18n";
const { t } = useI18n();

useHead({
    title: '503'
})
</script>
